import styled from "styled-components"
export const WrapperForm = styled.div`
    width: 100%;
`